import { Stack, Button, Inline, Box } from 'braid-design-system';
import { useState } from 'react';

import IndustryClassificationsField, {
  type SelectBoxIndustryGrouping,
} from 'src/components/IndustryClassificationsField/IndustryClassificationsField';
import LayoutBox from 'src/components/LayoutBox/LayoutBox';

interface Props {
  industryGroupings: SelectBoxIndustryGrouping[];
  setIndustryGroupings: (industryGroups: SelectBoxIndustryGrouping[]) => void;
}

const AddIndustries = ({ industryGroupings, setIndustryGroupings }: Props) => {
  const [editingMode, setEditingMode] = useState(false);

  if (editingMode) {
    return (
      <Box padding="medium" background="neutralLight">
        <Stack space="medium">
          <LayoutBox maxWidth={400}>
            <IndustryClassificationsField
              placeholder="Please select"
              hideClearAll={true}
              industryGroupings={industryGroupings}
              setIndustryGroupings={setIndustryGroupings}
            />
          </LayoutBox>
          <LayoutBox maxWidth={70}>
            <Button onClick={() => setEditingMode(false)}>Done</Button>
          </LayoutBox>
        </Stack>
      </Box>
    );
  }

  return (
    <Inline space="none">
      <Button
        variant="ghost"
        tone="formAccent"
        onClick={() => setEditingMode(true)}
      >
        Add another industry
      </Button>
    </Inline>
  );
};

export default AddIndustries;
